import { forwardRef, useEffect, useRef, useState } from "react";

/*eslint-disable */

declare const window: any;

interface MotorVehiculosComponentProps {
  motores: any;
}

const MotorVehiculosComponent = forwardRef<
  HTMLDivElement,
  MotorVehiculosComponentProps
>(({ motores }, ref) => {
  const infoContainerRef = useRef<HTMLDivElement | null>(null);
  const infoItemsRef = useRef<(HTMLDivElement | null)[]>([]);
  const imageContainerRef = useRef<HTMLDivElement | null>(null);
  const imageItemsRef = useRef<(HTMLDivElement | null)[]>([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedVersion, setSelectedVersion] = useState(0);
  const [selectedVersionColor, setSelectedVersioncolor] = useState(0);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  // Función para centrar un item dentro de su contenedor
  const scrollToCenter = (
    container: HTMLDivElement | null,
    item: HTMLDivElement | null
  ) => {
    if (!container || !item) return;

    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    const offset =
      itemRect.left -
      containerRect.left +
      container.scrollLeft -
      container.clientWidth / 2 +
      itemRect.width / 2;

    container.scrollTo({
      left: offset,
      behavior: "smooth",
    });
  };

  // mover scroll cuando cambia el index
  useEffect(() => {
    scrollToCenter(
      imageContainerRef.current,
      imageItemsRef.current[currentIndex]
    );
    scrollToCenter(
      infoContainerRef.current,
      infoItemsRef.current[currentIndex]
    );
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : motores?.engine?.gallery?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < motores?.engine?.gallery?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="motores-vehiculos-detail-component" ref={ref}>
      <div
        className="title-motores-vehiculos-detail-component"
        style={{ textAlign: motores?.engine?.alignment }}
      >
        {motores?.engine?.module_title}
      </div>

      <div
        ref={infoContainerRef}
        className="info-motores-vehiculos-detail-component"
        style={
          motores?.engine?.gallery?.length < 4
            ? { justifyContent: "center" }
            : {}
        }
      >
        <div
          className="btn-carrousel-motores-vehiculos-detail-component prev"
          onClick={handlePrev}
        >
          <img
            src="/assets/01_Home/Icon_Left.svg"
            alt="Ícono de flecha izquierda"
          />
        </div>
        {motores?.engine?.gallery?.map((item: any, index: number) => (
          <div
            ref={(el) => (infoItemsRef.current[index] = el)}
            className={`item-info-motores-vehiculos-detail-component ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
            key={index}
          >
            {item?.media_type === "img" ? (
              <img
                className="media-info-motores-vehiculos-detail-component"
                src={`https://manager.hyundaicolombia.co/${item.media?.url}`}
                alt={item.media_title || ""}
              />
            ) : item?.media_type === "video" ? (
              <video
                className="media-info-motores-vehiculos-detail-component"
                src={`https://manager.hyundaicolombia.co/${item.media?.url}`}
                autoPlay
                muted
                loop
                playsInline
              />
            ) : null}

            <div className="title-info-motores-vehiculos-detail-component">
              {item.media_title}
            </div>
            <div className="descripcion-info-motores-vehiculos-detail-component">
              {item.media_description}
            </div>
          </div>
        ))}

        <div
          className="btn-carrousel-motores-vehiculos-detail-component next"
          onClick={handleNext}
        >
          <img
            src="/assets/01_Home/Icon_Right.svg"
            alt="Ícono de flecha derecha"
          />
        </div>
      </div>

      <div className="description-motores-vehiculos-detail-component">
        La práctica constante del diseño gráfico y la investigación en
        experiencias digitales permiten ampliar la visión creativa, fortalecer
        la capacidad de análisis y mejorar la resolución de problemas. El
        estudio continuo asegura una evolución sólida y coherente dentro del
        ámbito profesional. 300 caracteres.
      </div>
      {/* <div className="version-modelos-vehiculos-detail-component">
        {motores?.motores?.map((model: any, index: number) => (
          <div
            key={index}
            className={`item-version-modelos-vehiculos-detail-component ${
              model.title === motores?.modelos[selectedVersion]?.title
                ? "active"
                : ""
            }`}
            onClick={() => setSelectedVersion(index)}
          >
            {model.title}
          </div>
        ))}
      </div>
      <div className="name-version-modelos-vehiculos-detail-component">
        Versión {motores?.modelos[selectedVersion]?.title}
      </div>
      <div className="precio-version-modelos-vehiculos-detail-component">
        Disponible desde {formatCurrency(motores?.modelos[selectedVersion]?.price)} *
      </div>
      <div className="asset-color-version-modelos-vehiculos-detail-component">
        <div className="asset-version-modelos-vehiculos-detail-component">
          {motores?.modelos[selectedVersion]?.colors[selectedVersionColor].image !== null ? (
            <img
              src={`https://manager.hyundaicolombia.co/${motores?.modelos[selectedVersion]?.colors[selectedVersionColor].image?.url}`}
              alt={`Imagen del modelo ${motores?.modelos[selectedVersion]?.title} en color ${motores?.modelos[selectedVersion]?.colors[selectedVersionColor].name}`}
            />
          ) : null}
        </div>
        <div className="control-color-version-modelos-vehiculos-detail-component">
          <div
            className="colores-control-color-version-modelos-vehiculos-detail-component"
            style={
              motores?.modelos[selectedVersion]?.colors?.length === 1
                ? { justifyContent: "center" }
                : {}
            }
          >
            {motores?.modelos[selectedVersion]?.colors.map(
              (color: any, e: number) => (
                <div
                  key={e}
                  className={
                    motores?.modelos[selectedVersion]?.colors[selectedVersionColor].name === color.name
                      ? "active"
                      : ""
                  }
                  style={{
                    backgroundColor: color.color,
                    border: `2px solid ${color.color}`,
                  }}
                  onClick={() => setSelectedVersioncolor(e)}
                ></div>
              )
            )}
          </div>
          <div className="title-control-color-version-modelos-vehiculos-detail-component">
            {motores?.modelos[selectedVersion]?.colors[selectedVersionColor].name}
          </div>
          <div className="politica-control-color-version-modelos-vehiculos-detail-component">
            *Los valores y precios publicados son de referencia y pueden variar sin previo aviso. Las imágenes son ilustrativas, algunas características de los vehículos de las imágenes pueden variar.
          </div>
        </div>
      </div>
      <div className="caracteristica-version-modelos-vehiculos-detail-component">
        {motores?.modelos[selectedVersion]?.features.map(
          (item: any, index: number) => (
            <div key={index} className="item-caracteristica-version-modelos-vehiculos-detail-component">
              <div className="title-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.title}
              </div>
              <div className="description-item-caracteristica-version-modelos-vehiculos-detail-component">
                {item?.description}
              </div>
            </div>
          )
        )}
      </div> */}
    </div>
  );
});

export default MotorVehiculosComponent;
